import React, { FC, useMemo } from 'react';
import { graphql } from 'gatsby';

import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';

import { articleFormatDate } from 'utils/helpers';

import { IArticleDateProps } from './model';
import './ArticleDate.scss';

const ArticleDate: FC<IArticleDateProps> = ({ articleConfigs, createDate, updateDate, lang }) => {
  const { createDateText, updateDateText } = articleConfigs;
  const { articleUpdateDate, articleCreateDate } = useMemo(
    () => ({
      articleUpdateDate: updateDate ? articleFormatDate(updateDate, lang) : '',
      articleCreateDate: createDate ? articleFormatDate(createDate, lang) : '',
    }),
    [updateDate, createDate]
  );

  return (
    <div className="article-date container">
      <div className="article-date__wrapper">
        <DangerouslySetInnerHtml className="article-date__text" html={createDateText} />
        <DangerouslySetInnerHtml className="article-date__date" html={articleCreateDate} />
      </div>
      <div className="article-date__wrapper">
        <DangerouslySetInnerHtml className="article-date__text" html={updateDateText} />
        <DangerouslySetInnerHtml className="article-date__date" html={articleUpdateDate} />
      </div>
    </div>
  );
};

export const query = graphql`
  fragment FragmentArticleConfigs on ArticleConfigs {
    createDateText
    updateDateText
  }
`;

export default ArticleDate;
